import UnauthorizedAccess from "../components/layout/UnauthorizedAccess"

export default [
  { name: 'UnauthorizedAccess', path: '/401', component: UnauthorizedAccess}
]
